/** Docs (UA): https://prostopay.atlassian.net/wiki/spaces/SW/pages/1902641182 — CompletePage */

import { useTranslation } from 'react-i18next';

import { useAppStore } from '../../../../shared/hooks/useAppStore';
import { getVmDetails } from '../../../../shared/lib/general';
import { usePurchaseActions } from '../../../../shared/hooks/usePurchaseActions';
import { ContentBox, PrimaryButton, ScreenTitle, ScreenWrapper } from '../../../../shared/ui';
import { AnimatedIcon } from '../../../../shared/ui/AnimatedIcon/AnimatedIcon';
import tickAnimation from '../../../../shared/ui/AnimatedIcon/animations/tick.json';
import styles from './CompletePage.module.css';

export const CompletePage = () => {
    const { t } = useTranslation();
    const vm = useAppStore((s) => s.vm);
    const { onRepeatPurchaseClickHandler } = usePurchaseActions();
    const { isFridge, isAllowed } = getVmDetails(vm);

    return (
        <ScreenWrapper>
            <ScreenTitle>{t('Thank for answers')} </ScreenTitle>
            <ContentBox className={styles.tickAnimationWrapper}>
                <AnimatedIcon loop={false} animationData={tickAnimation} />
            </ContentBox>
            {(isAllowed || isFridge) && (
                <PrimaryButton onClick={() => onRepeatPurchaseClickHandler()}>
                    {t('Repeat_purchase')}
                </PrimaryButton>
            )}
        </ScreenWrapper>
    );
};
